/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppSharedCreateByUserQueryResponse,
  GetApiV1NotificationMobileAppSharedCreateByUserQueryParams,
  GetApiV1NotificationMobileAppSharedCreateByUser401,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedCreateByUser.ts";

function getGetApiV1NotificationMobileAppSharedCreateByUserUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app/shared/create-by-user` as const,
  };
  return res;
}

/**
 * @description Lista os usuários que criaram notificações. **(Requer Authorization para autenticação)**
 * @summary Retorna os usuários que criaram notificações (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/create-by-user}
 */
export async function getApiV1NotificationMobileAppSharedCreateByUser(
  params?: GetApiV1NotificationMobileAppSharedCreateByUserQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppSharedCreateByUserQueryResponse,
    ResponseErrorConfig<GetApiV1NotificationMobileAppSharedCreateByUser401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppSharedCreateByUserUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
